<!-- Resize -->
<div *ngIf="pageType != 'fullscreen'" class="resize resize__left" (resize)="onResizeSide($event)"
  [targetElement]="offcanvasRightMailView" [direction]="AngularResizeElementDirection.LEFT">
</div>

<!-- Mail List Container -->
<div class="mail-container">

  <!-- Fullscreen Header -->
  <div class="row m-2" *ngIf="pageType === 'fullscreen'">
    <div class="col-6">
      <ng-container *ngIf="!accessPermission">
        <button class="mail-button" mat-flat-button color="primary" (click)="openMailpopup('fullscreen')">
          <div class="du-mail-button">
            <mat-icon svgIcon="notification_mail" class="du-new-mail-mat-icon-btn"></mat-icon>
            <span>New Mail</span>
          </div>
        </button>
      </ng-container>

      <ng-container *ngIf="accessPermission">
        <!-- Backdrop to close dropdown when clicking outside -->
        <div *ngIf="isMailDropdownOpen" class="dropdown-backdrop" (click)="closeMailDropdown()"></div>

        <!-- new mail button with similar design -->
        <div class="scraii-mail-dropdown-wrapper">
          <button type="button" class="scraii-mail-main-btn" (click)="toggleMailDropdown()">
            <mat-icon svgIcon="notification_mail" class="du-new-mail-mat-icon-btn"></mat-icon>
            Sent Mail
          </button>
          <div class="scraii-mail-dropdown-list" [class.open]="isMailDropdownOpen">
            <button type="button" class="scraii-mail-item" (click)="openMailpopup('fullscreen'); closeMailDropdown()">
              New Mail
            </button>
            <button type="button" class="scraii-mail-item" (click)="goEmailExtracts(); closeMailDropdown()">
              Email Extracts
            </button>
          </div>
        </div>
      </ng-container>

    </div>

    <div class="col-6">
      <span class="du-top-search-secure">
        <input type="search" [(ngModel)]="searchText" class="du-top-search-secure-box" placeholder="Search" />
        <mat-icon svgIcon="search" class="du-mat-search-icon"></mat-icon>
      </span>
    </div>
  </div>

  <!-- Sidebar Header -->
  <div class="d-flex align-items-center justify-content-between p-2" *ngIf="pageType === 'sidebar'"
    style="margin:0px 10px">
    <span class="header">Mails</span>
    <div class="d-flex align-items-center gap-2">
      <mat-icon matTooltip="Sorting" svgIcon="notes_sorting" class="custom-icon"
        (click)="sortEmailsByDate()"></mat-icon>
      <span style="display:inline-block; position:relative">
        <input type="search" [(ngModel)]="searchText" class="du-top-search-secure-box" style="position:relative"
          placeholder="Search" />
        <mat-icon svgIcon="notes_search" class="du-mat-search-icon"
          style="position : absolute; width:30px;height:35px;margin-top: 3px;"></mat-icon>
      </span>
    </div>
    <mat-icon class="add_new_mail" matTooltip="Add New Mail" svgIcon="add_new_mail"
      (click)="openMailpopup('sidebar')"></mat-icon>
  </div>
  <hr *ngIf="pageType === 'sidebar'" class="du-mail-hr" style="border: 1px solid #E8EAEE;" />

  <!-- Tabs -->
  <div class="new-inbox" *ngIf="pageType === 'fullscreen'">
    <div class="du-toggle-pills-container">
      <div class="du-toggle-pills rounded-pill p-1 d-flex gap-2 w-100 justify-content-center">
        <ng-container *ngFor="let tab of ['inbox', 'sent']">
          <button
            class="btn rounded-pill px-4 py-1 d-flex align-items-center justify-content-center p-2 w-50 btn-toggle-pill-bg"
            [ngClass]="{
              'btn-white text-dark bg-white': selectedTab === tab,  
              'btn-light text-muted': selectedTab !== tab  
            }" (click)="onTabChange(tab)">
            <mat-icon [svgIcon]="tab === 'inbox' ? 'inbox' : 'send'" style="width: 16px"
              class="icon-{{ tab }}"></mat-icon>
            <span class="du-toggle-tab-name">{{ tab | titlecase }}</span>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <br *ngIf="pageType === 'fullscreen'" />

  <!-- Mail List Section -->
  <div class="mail-list-container"
    [ngStyle]="{ height: pageType === 'sidebar' ? 'calc(100dvh - 63px)' : 'calc(100dvh - 247px)' }">

    <!-- Loader -->
    <app-progress-indefinite class="progress-indicator" *ngIf="isLoading"
      [ngStyle]="{ 'margin-top': pageType === 'fullscreen' ? '100px' : '150px' }"></app-progress-indefinite>

    <!-- Mail List -->
    <div class="mail-list" *ngIf="!isLoading" [ngClass]="{ 'fullscreen-margin': pageType === 'fullscreen' }">
      <div class="mail-card" *ngFor="let mail of emails | searchText:searchText" (click)="openMailPreview(mail.id)">
        <div class="mail-info">
          <span class="mail-from" [matTooltip]="selectedTab === 'inbox' 
        ? mail.from?.emailAddress?.address 
        : getRecipientsAddresses(mail)">

            <!-- Inbox sender -->
            <ng-container *ngIf="selectedTab === 'inbox'; else recipientsList">
              {{ mail.from?.emailAddress?.name }}
            </ng-container>

            <!-- Sent Items recipients -->
            <ng-template #recipientsList>
              {{ getRecipientsNames(mail) }}
            </ng-template>
          </span>



          <span class="mail-subject" matTooltip="{{ mail.subject ? mail.subject : 'No Subject' }}"
            [ngClass]="{ 'mail-subject-highlight': mail.isUnread }">
            {{ mail.subject ? mail.subject: 'No Subject' }}
          </span>
          <p class="mail-preview" matTooltip="{{ mail.bodyPreview }}">
            {{ mail.bodyPreview }}
          </p>
        </div>
        <div class="mail-footer d-flex align-items-center justify-content-between">
          <div class="time-and-dot d-flex align-items-center gap-2">
            <span class="mail-time">{{ mail.receivedDateTime | date: 'hh:mm a | dd.MM.yy' }}</span>
          </div>
          <div class="icon-group d-flex align-items-center gap-1">
            <mat-icon *ngIf="mail?.attachments?.length > 0" matTooltip="Attachments" svgIcon="share_file"
              class="icon-w"></mat-icon>
            <mat-icon *ngIf="selectedTab === 'inbox'" matTooltip="Secured Mail" svgIcon="lock_icon"
              class="icon-w"></mat-icon>
          </div>
        </div>
      </div>

      <!-- No Mail Message -->
      <div *ngIf="emails.length === 0" class="p-3 text-center text-muted">
        No {{ selectedTab }} emails to display.
      </div>
    </div>
  </div>
</div>

<!-- Resize Bottom -->
<div class="resize resize__bottom--left" (resize)="onResizeSide($event)" [targetElement]="offcanvasRightMailView"
  [direction]="AngularResizeElementDirection.BOTTOM_LEFT">
</div>